








import { Vue, Component, Watch } from "vue-property-decorator";

@Component({
  name: "App",
  components: {}
})
export default class App extends Vue {}
